import { IsInt } from 'class-validator';

export class OrderCashPaymentConfirmRequest {
    @IsInt()
    public orderId: number;

    constructor(data?: Partial<OrderCashPaymentConfirmRequest>) {
        this.orderId = data?.orderId;
    }
}
